var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{class:_vm.fadeClasses},[_c('p',[_vm._v("En dat begint heel simpel.")]),_c('h3',{staticClass:"title"},[_vm._v("Wie ben jij? Kies je leeftijd en geslacht.")])])}
var staticRenderFns = []

export { render, staticRenderFns }